import ChatLayout from 'layout/chat/wholesaler/chatLayout';
import {ProtectedRoute} from 'modules/protectedRoute/market';
import {RouteObject} from 'react-router-dom';
import ChatsFormContainer from './chatsContainer';
export const WholesalerChatRoutes: RouteObject[] = [
  {
    path: 'wholesaler/chat-form',
    element: (
      <ProtectedRoute>
        <ChatLayout />
      </ProtectedRoute>
    ),
    errorElement: <>error page</>,
    children: [
      {
        index: true,
        path: ':chatId',
        element: <ChatsFormContainer />,
      },
    ],
  },
];
